import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	title: {
		id: 'software-cycle-time-breakdown-report.header.title',
		defaultMessage: 'Cycle time',
		description:
			"The direct translation of this term is the length of time to complete one 'period' or one 'iteration' of a particular process. This will be the page title for Cycle time breakdown reports page. This report will provide customers with a view that helps them understand where their bottlenecks are in their delivery pipeline so that they know where to focus their attention to improve. It will provide metrics outlining how long it takes for certain processes in the pipeline to be completed i.e. the 'Cycle Time'.",
	},
	description: {
		id: 'software-cycle-time-breakdown-report.header.description',
		defaultMessage:
			"Understand your project's Cycle Time to see how quickly you ship value. Your cycle time is the time it takes an issue to go from first commit to last production deployment based on development and CI/CD data.",
		description: 'Text providing a quick overview of the purpose of the reports page',
	},
	learnMore: {
		id: 'software-cycle-time-breakdown-report.header.learn-more',
		defaultMessage: 'Learn more',
		description: 'Text providing a quick overview of the purpose of the reports page',
	},
});
